<div class="wrap">
  <div class="img">
    <app-img-icone [src]="itemMenu.svg_Blue" *ngIf=" whiteOrBlue"></app-img-icone>
  </div>
  <div class="name">
    <p>{{itemMenu.title_Drawer}}</p>
    <mat-checkbox class="example-margin" [(ngModel)]="inMyMenu" (click)="isInMyMenu($event)" *ngIf="!visibility">
    </mat-checkbox>
  </div>
</div>